import React, { Component } from "react";
import { connect } from 'react-redux';
import { activateWebsite } from '../Claim/activatewebsite';
import "../../assets/css/dashboard.css";
import PopupModal from './popups/PopupModal';
import apiInstance from "../apiInstance";
import withRouter from '../../utility/withRouter';

class Domains extends Component {
    constructor(props) {
        super(props);
        this.state = {
            websites: [],
            currentWebsite: "",
            skeletonLoading: true,
            alreadyHasDomain: true,
            existingDomain: "",
            isNewDomain: false,
            newDomain: "",
            isDomainAvail: "",
            dnra: {
                title: "",
                // content: '',
                url: "",
            },
            dnraAccept: false,
            // dnsInfo: {},
            domainProcessMsg: "",
            error: ""
        };
        this.popupRef = React.createRef();
    }

    async componentDidMount() {
        await apiInstance
            .get("/dashboard/websites")
            .then((response) => {
                this.setState({ error: "" });
                const websites = response.data.websites;
                let currentWebsite = null;

                const storedWebsiteId = localStorage.getItem('currentWebsiteId');

                if(storedWebsiteId) {
                    currentWebsite = websites.find(item => item._id === storedWebsiteId);
                }

                if(!currentWebsite && websites.length > 0) {
                    currentWebsite = websites[0];
                }

                this.setState(() => {
                    return {
                        websites: websites,
                        currentWebsite: currentWebsite,
                        // dnsInfo: currentWebsite?.dsnRecords,
                    };
                });

                if(currentWebsite) {
                    localStorage.setItem('currentWebsiteId', currentWebsite._id);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
        this.setState({skeletonLoading: false});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name === "newDomain") {
            this.setState({ isDomainAvail: "" });
        }
    };

    handleCheckboxChange = (e) => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    delayWithCountdown = async (seconds) => {
        return new Promise((resolve) => {
            const countdownEl = document.getElementById("countdown");
            let remaining = seconds;

            countdownEl.textContent = `Please wait ${remaining} seconds...`;

            const interval = setInterval(() => {
                remaining--;
                if (remaining > 0) {
                    countdownEl.textContent = `Please wait ${remaining} seconds...`;
                } else {
                    countdownEl.textContent = "";
                    clearInterval(interval);
                    resolve();
                }
            }, 1000);
        });
    };

    existingDomain = () => {
        this.setState({ alreadyHasDomain: true });
        this.setState({ isNewDomain: false });
        this.setState({ error: "" });
    };

    addExistingDomain = () => {
        const domainToAdd = this.state.existingDomain;
        if(domainToAdd !== ''){
            this.processDomain(domainToAdd);
        }
        else{
            this.setState({ error: "Please enter your domain to proceed." });
        }
    };

    newDomain = () => {
        this.setState({ isNewDomain: true });
        this.setState({ alreadyHasDomain: false });
        this.setState({ error: "" });
    };

    searchDomain = async () => {
        const domainToSearch = this.state.newDomain;
        if(domainToSearch !== ''){
            this.setState({ domainProcessMsg: "Searching for Domain..." });
            const request_body = {
                domain: this.state.newDomain,
            };
            await apiInstance
                .post("/domain", request_body)
                .then((response) => {
                    this.setState({ error: "" });
                    if (
                        response.data.domainInfo.available === true &&
                        response.data.domainInfo.price < 15000000
                    ) {
                        // if cost is less than $15.00
                        this.setState({ isDomainAvail: "yes" });
                    } else {
                        this.setState({ isDomainAvail: "no" });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    this.setState({ isDomainAvail: "" });
                    this.setState({ error: error.response?.data?.error || "Something went wrong, please try again later." });
                });
            this.setState({ domainProcessMsg: "" });
        }
        else{
            this.setState({ error: "Please enter a domain to search for its availability." });
        }
    };

    getDnra = async () => {
        this.setState({ domainProcessMsg: "Getting DNRA agreement..." });
        const request_body = {
            domain: this.state.newDomain,
        };
        await apiInstance
            .post("/domain/dnra", request_body)
            .then((response) => {
               this.setState({ error: "" });
                this.setState({
                    dnra: {
                        title: response.data.dnra.title,
                        // content: response.data.dnra.content,
                        url: response.data.dnra.url,
                    },
                });
                this.setState({ domainProcessMsg: "" });
                this.purchaseDomain();
            })
            .catch((error) => {
                this.setState({ domainProcessMsg: "" });
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
    };

    purchaseDomain = () => {
        this.setState({ domainProcessMsg: "Purchasing Your Domain. Please wait..." });
        const domainToAdd = this.state.newDomain;
        const request_body = {
            domain: domainToAdd,
        };
        apiInstance
            .post("/domain/purchase", request_body)
            .then(async (response) => {
                this.setState({ error: "" });
                this.setState({ domainProcessMsg: "Domain Purchased!" });

                // Wait for 60 seconds if in Production mode
                if (!process.env.REACT_APP_SERVER_URL.includes("localhost")) {
                    await this.delayWithCountdown(60);
                }

                const domainOrderId = response.data?.data?.orderId; // data.
                
                this.processDomain(domainToAdd, domainOrderId);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
    };

    // Process the newly purchased or existing added domain for internal use
    processDomain = async (domainToAdd, domainOrderId = 0) => {
        this.setState({ domainProcessMsg: 'Processing the Domain. Please wait...' });

        domainToAdd = domainToAdd.replace('http://', '').replace('https://', '').replace('www.', '');

        const request_body = {
            siteId: this.state.currentWebsite._id,
            siteName: this.state.currentWebsite.siteName,
            domain: domainToAdd,
            domainOrderId: domainOrderId,
        };
        await apiInstance
            .post("/domain/process", request_body)
            .then((response) => {
                this.setState({ error: "" });
                const dns_info = response.data.dns;
                const newUrl = `https://${domainToAdd}`;

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        currentWebsite: {
                            ...prevState.currentWebsite,
                            siteUrl: newUrl,
                            domain_order_id: domainOrderId,
                            dsnRecords: dns_info
                        },
                        // dnsInfo: dns_info,
                    };
                });
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
            this.setState({ domainProcessMsg: "" });
    };

    handleCurrentSiteChange = (e) => {
        const selectedSite = e.target.value;
        let siteIndex = 0;
        this.state.websites.map((website, index) =>
            website.siteName === selectedSite ? (siteIndex = index) : ""
        );

        const currentWebsite = this.state.websites[siteIndex];
        this.setState({ currentWebsite: currentWebsite });

        if(currentWebsite) {
            localStorage.setItem('currentWebsiteId', currentWebsite._id);
        } else {
            localStorage.removeItem('currentWebsiteId');
        }
    };

    deleteDomain = async () => {
        this.setState({ domainProcessMsg: 'Deleting the Domain. Please wait...' });
        const request_body = {
            siteId: this.state.currentWebsite._id,
            oldUrl: this.state.currentWebsite.siteUrl,
        };
        await apiInstance
            .post("/domain/delete", request_body)
            .then((response) => {
                this.setState({ error: "" });
                const site = response.data.website;
                this.setState({ currentWebsite: site });
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ error: error.response?.data?.message || "Something went wrong, please try again later." });
            });
            this.setState({ domainProcessMsg: "" });
    };

    activateNow = async (siteId) => {
        try {
            await activateWebsite({
                siteId,
                userEmail: this.props.user?.email
            });
        } catch (err) {
            console.error('Checkout failed:', err.message);
            this.setState({ error: err.message || "Request failed. Please contact us." });
        }
    }

    render() {
        const websites = Array.isArray(this.state.websites)
            ? this.state.websites
            : [];
        const skeletonLoading = this.state.skeletonLoading;
        const alreadyHasDomain = this.state.alreadyHasDomain;
        const isNewDomain = this.state.isNewDomain;
        const isDomainAvail = this.state.isDomainAvail;
        const newDomain = this.state.newDomain;
        const dnra = this.state.dnra;

        const currSiteId = this.state.currentWebsite?._id;
        const dnsInfo = this.state.currentWebsite?.dsnRecords; // this.state.dnsInfo;
        const domainProcessMsg = this.state.domainProcessMsg;
        const siteUrl = this.state.currentWebsite?.siteUrl;

        const mainDomain = process.env.REACT_APP_MAIN_DOMAIN;
        const isTestSite = siteUrl?.includes(mainDomain);

        const currSiteCodeName = this.state.currentWebsite?.siteName;
        const currSiteName = this.state.currentWebsite?.name;
        const currDomainOrderId = this.state.currentWebsite?.domain_order_id;
        const error = this.state.error;

        const placeholderText = currSiteName ? "e.g. " + currSiteName.replace(/\s/g, '').toLowerCase() + ".com" : '';
        const currSiteSubscriptionStatus = this.state.currentWebsite?.subscription?.status || '-';

        return (
            <>
                {websites?.length > 0 &&
                    <div className="mjs-dash-top">
                        <div className="mjs-dash-top-site-dd">
                            <span>Active Website </span>
                            <select
                                className="mjs-select"
                                value={currSiteCodeName}
                                onChange={this.handleCurrentSiteChange}
                            >
                                {websites.map((website, index) => (
                                    <option
                                        key={website._id}
                                        value={website.siteName}
                                    >
                                        {website.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }
                
                <div className="mjs-dash-section">
                    <h4>Domain Setup</h4>

                    {this.state.currentWebsite ? (
                        <>
                            <p className="mjs-m-0">Connect a custom domain to {skeletonLoading !== false ? <span className='mjs_pre_skeleton_text mjs-width-10'></span> : currSiteName}</p>

                            {error && <div className="mjs_text_error">{error}</div>}
                            
                            {
                            skeletonLoading !== false ? 
                                <div className="mjs-dash-sec-card">
                                    <div className='mjs_pre_skeleton_text mjs-width-10'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-30'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                </div>
                            :
                                isTestSite ? (
                                    <div className="mjs-dash-sec-card">
                                        
                                        <div className="mjs-dash-tab-sec">
                                            <span
                                                className={`mjs-dash-tab ${alreadyHasDomain ? 'active' : ''}`}
                                                onClick={() =>
                                                    this.existingDomain()
                                                }
                                            >
                                                Connect Existing Domain
                                            </span>
                                            <span
                                                className={`mjs-dash-tab ${isNewDomain ? 'active' : ''}`}
                                                onClick={() => this.newDomain()}
                                            >
                                                New Domain (FREE)
                                            </span>
                                        </div>

                                        {isNewDomain && (
                                            <div className="mjs-tab-container">
                                                {
                                                !currDomainOrderId || currDomainOrderId === 0 ? (
                                                    <>
                                                    
                                                    {currSiteSubscriptionStatus !== "active" ?
                                                        <div>
                                                            <p className="mjs_text_error">
                                                                <span className="mjs-mr-5">Free Domain Locked. Activate your website to claim your free domain.</span>
                                                                <span className="mjs-ml-5 mjs-quick-action-link" onClick={() => this.activateNow(currSiteId)}>Activate Now</span>
                                                            </p>
                                                        </div>
                                                    :
                                                        <>
                                                            <p>Search for your new domain below.</p>
                                                            <div className="mjs-dash-row mjs-input-btn-inline">
                                                                <input
                                                                    className="mjs-input"
                                                                    type="text"
                                                                    name="newDomain"
                                                                    value={newDomain}
                                                                    onChange={this.handleChange}
                                                                    placeholder={placeholderText}
                                                                />
                                                                <span
                                                                className="mjs-btn mjs-btn-primary"
                                                                    onClick={() => this.props.navigate("/support")}
                                                                    // onClick={() =>
                                                                    //     this.searchDomain()
                                                                    // }
                                                                >
                                                                    {/* Search Domain */}
                                                                    Contact Support
                                                                </span>
                                                            </div>
                                                            <p className="mjs_text_grey">Tip: Use keywords like <strong>homes</strong>, <strong>rentals</strong>, or <strong>realty</strong> to find the best domain for your business.</p>

                                                            <hr />

                                                            <h4 className="mjs-fs-20">{(isDomainAvail === "yes" || isDomainAvail === "no") ? 'Domain Availability Results' : 'Why Register a Custom Domain?'}</h4>
                                                            <br />

                                                            <div className="mjs-dash-sec-card-container">

                                                                <div className="mjs-dash-sec-card-level-1 mjs-width-70">
                                                                    {
                                                                    domainProcessMsg ? (
                                                                        <p>
                                                                            {domainProcessMsg} <i className="fa-solid fa-spinner fa-spin"></i> 
                                                                            <span id="countdown"></span>
                                                                        </p>
                                                                    )
                                                                    :
                                                                    isDomainAvail === "yes" ? (
                                                                        <>
                                                                            {dnra.title ? (
                                                                                <>
                                                                                    <p><i class="fa-solid fa-arrow-right mjs-mr-5"></i> Please accept the DNRA agreement and click continue button</p>
                                                                                    <div className="mjs-dash-row">
                                                                                        <div className="mjs-dash-col">
                                                                                            <h5>{dnra.title}</h5>
                                                                                            <a className="mjs-link" href={dnra.url} target="_blank" rel="noreferrer">Read Full Agreement here</a>
                                                                                            <label><input type="checkbox" name="dnraAccept" checked={this.state.dnraAccept} onChange={this.handleCheckboxChange}/>I agree</label>
                                                                                        </div>
                                                                                        <span className="mjs-btn mjs-btn-primary" onClick={() => this.purchaseDomain()}>Continue</span>
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                            :
                                                                            (
                                                                                <div className="mjs-dash-row">
                                                                                    <p className="mjs-m-0"><i class="mjs_text_green fa-solid fa-check mjs-mr-5"></i> Good News! The domain {newDomain} is available.</p>
                                                                                    <span className="mjs-btn mjs-btn-primary" onClick={() => this.getDnra() }>Continue</span>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    ) : isDomainAvail === "no" ? (
                                                                        <div className="mjs-dash-row">
                                                                            <p className="mjs-m-0"><i class="fa-solid fa-circle-exclamation mjs_text_error mjs-mr-5"></i> The domain {newDomain} is not available. Please search for another domain.</p>
                                                                        </div>
                                                                    )
                                                                    :
                                                                    (
                                                                        <div className="mjs-check-list">
                                                                            <div><i class="mjs_text_light_blue fa-solid fa-check"></i> A professional URL like {placeholderText.replace('e.g.','')}</div>
                                                                            <div><i class="mjs_text_light_blue fa-solid fa-check"></i> Improved SEO - Better search engine results</div>
                                                                            <div><i class="mjs_text_light_blue fa-solid fa-check"></i> Brand credibility - Makes your business trustworthy</div>
                                                                            <div><i class="mjs_text_light_blue fa-solid fa-check"></i> No additional cost - We provide one free domain per website.</div>
                                                                        </div>
                                                                    )}


                                                                </div>

                                                                <div className="mjs-dash-sec-card-level-1 mjs-width-30">
                                                                    <h4 className="mjs-fs-20">Need Help?</h4>
                                                                    <p>If you need assistance setting up your domain, our support team is here to help you.</p>
                                                                    <span className="mjs-btn" onClick={() => this.props.navigate("/support")}>Contact Support</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                        }
                                                    </>
                                                )
                                                :
                                                    <p>You have already claimed your free domain for {currSiteName}. Please use the Connect Existing Domain tab.</p>
                                                }

                                            </div>
                                        )}

                                        {alreadyHasDomain && (
                                            <div className="mjs-tab-container">
                                                {currSiteSubscriptionStatus !== "active" ?
                                                    <div>
                                                        <p className="mjs_text_error">
                                                            <span className="mjs-mr-5">Domain Connection Locked. Activate your website to connect a custom domain.</span>
                                                            <span className="mjs-ml-5 mjs-quick-action-link" onClick={() => this.activateNow(currSiteId)}>Activate Now</span>
                                                        </p>
                                                    </div>
                                                :
                                                <>
                                                    <p>Enter your existing domain to connect to your website.</p>
                                                    <div className="mjs-dash-row mjs-input-btn-inline">
                                                        <input
                                                            className="mjs-input"
                                                            type="text"
                                                            name="existingDomain"
                                                            value={
                                                                this.state
                                                                    .existingDomain
                                                            }
                                                            onChange={this.handleChange}
                                                            required
                                                            placeholder={placeholderText}
                                                        />
                                                        <span
                                                            className="mjs-btn mjs-btn-primary"
                                                            onClick={() =>
                                                                this.addExistingDomain()
                                                            }
                                                        >
                                                            Connect Domain
                                                        </span>
                                                    </div>
                                                    <p className="mjs_text_grey">You will be given DNS records after connecting the domain. Make sure you update your DNS settings with your domain registrar.</p>
                                                    
                                                    <hr />

                                                    <h4 className="mjs-fs-20">Domain Connection Instructions</h4>
                                                    <br />

                                                    <div className="mjs-dash-sec-card-container">

                                                        <div className="mjs-dash-sec-card-level-1 mjs-width-70 mjs-check-list">
                                                            <div><i class="mjs_text_light_blue fa-solid fa-arrow-right"></i> Enter your domain and click Connect Domain button</div>
                                                            <div><i class="mjs_text_light_blue fa-solid fa-arrow-right"></i> The server will process the domain and display DNS entries</div>
                                                            <div><i class="mjs_text_light_blue fa-solid fa-arrow-right"></i> Copy DNS entries and update at your domain registrar</div>
                                                            <div><i class="mjs_text_light_blue fa-solid fa-arrow-right"></i> DNS usually takes 24 to 48 hours to update at the registrar</div>
                                                        </div>

                                                        <div className="mjs-dash-sec-card-level-1 mjs-width-30">
                                                            <h4 className="mjs-fs-20">Need Help?</h4>
                                                            <p>If you need assistance setting up your domain, our support team is here to help you.</p>
                                                            <span className="mjs-btn" onClick={() => this.props.navigate("/support")}>Contact Support</span>
                                                        </div>
                                                    </div>

                                                    {domainProcessMsg ?
                                                        <p>
                                                            {domainProcessMsg} <i className="fa-solid fa-spinner fa-spin"></i> 
                                                            <span id="countdown"></span>
                                                        </p>
                                                        :
                                                        ''
                                                    }
                                                </>
                                                }

                                            </div>
                                        )}

                                    </div>
                                ) : (
                                    <div className="mjs-dash-sec-card">
                                        <div className="mjs-dash-row">
                                            <p>
                                                <i className="mjs_text_green fa-solid fa-circle-check"></i> Domain Connected - <a class="mjs-i-action mjs-link" target="_blank" rel="noreferrer" href={siteUrl}>{siteUrl} <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                                            </p>

                                            {/* {!currDomainOrderId || currDomainOrderId === 0 && ( */}
                                                <span className="mjs-btn mjs_text_error" 
                                                    onClick={() => {
                                                        if (this.popupRef.current) {
                                                            this.popupRef.current.openPopup(
                                                                "deleteDomain"
                                                            );
                                                        }
                                                    }}
                                                >Delete Domain</span>
                                            {/* )} */}
                                        </div>

                                        {
                                        !currDomainOrderId || currDomainOrderId === 0 ? (
                                            <>
                                            <p>Please add these DNS entries to your domain host. It usually takes 24 to 48 hours to update DNS at the Registrar.</p>
                                            <table className="mjs-table">
                                                <thead>
                                                    <th>Type</th>
                                                    <th>Name</th>
                                                    <th className="mjs-width-60">Data</th>
                                                    <th>TTL</th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>A</td>
                                                        <td>@</td>
                                                        <td>{dnsInfo?.a?.at}</td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>A</td>
                                                        <td>mail</td>
                                                        <td>{dnsInfo?.a?.mail}</td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>MX</td>
                                                        <td>@</td>
                                                        <td>
                                                            {dnsInfo?.mx?.at?.name}{" "}
                                                            (priority{" "}
                                                            {
                                                                dnsInfo?.mx?.at
                                                                    ?.priority
                                                            }
                                                            )
                                                        </td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TXT</td>
                                                        <td>@</td>
                                                        <td>{dnsInfo?.txt?.at}</td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TXT</td>
                                                        <td>admin</td>
                                                        <td>
                                                            {dnsInfo?.txt?.admin}
                                                        </td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TXT</td>
                                                        <td>_dmarc</td>
                                                        <td>
                                                            {dnsInfo?.txt?._dmarc}
                                                        </td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                    <tr>
                                                        <td>TXT</td>
                                                        <td>
                                                            {
                                                                dnsInfo?.txt?.dkim
                                                                    ?.key
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                dnsInfo?.txt?.dkim
                                                                    ?.value
                                                            }
                                                        </td>
                                                        <td>600 seconds</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </>
                                        )
                                        :
                                        ''
                                        }

                                        {/* {JSON.stringify(dnsInfo)} */}

                                        {
                                            domainProcessMsg ? 
                                            <p>
                                                {domainProcessMsg} <i className="fa-solid fa-spinner fa-spin"></i>
                                            </p>
                                            :
                                            ''
                                        }

                                    </div>
                                )
                            }
                        </>
                    ) : (
                        skeletonLoading !== false ? 
                        <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        : 
                        <p className='mjs_text_error'>You don't have any website yet!.</p>
                    )}
                </div>
                
                {<PopupModal
                    ref={this.popupRef}
                    deleteDomain={this.deleteDomain}
                />}

            </>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(withRouter(Domains));
